import Product from '@/classes/products/Product'

export default class Products extends Array {
  constructor (products, ...rest) {
    Array.isArray(products) ? super(...products.map(product => new Product(product))) : super(...rest)
  }
}
